import { CartLinesUpdateEvent } from '@shopify/events';
import '@theme/theme-drawer';

let pending = false;
const cartSections = () => [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
async function applyWelcomeDiscount(cart) {
  if (!cart.items.some(item => !item.selling_plan_allocation)) return cart;
  const codes = cart.discount_codes || [];
  if (codes.some(code => code.code.toUpperCase() === 'WELCOME45' && code.applicable)) return cart;
  if (codes.some(code => !['WELCOME15', 'WELCOME55', 'WELCOME45'].includes(code.code.toUpperCase()))) return cart;
  if (cart.cart_level_discount_applications?.some(discount => !['WELCOME15', 'WELCOME55', 'WELCOME45'].includes(discount.title.toUpperCase()))) return cart;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount:'WELCOME45', sections:cartSections(), sections_url:location.pathname})});
    if (!response.ok) return cart;
    return await response.json();
  } catch { return cart; }
}
async function refreshWelcomeCart() {
  if (pending) return;
  const response = await fetch(`${window.Shopify.routes.root}cart.js`, {headers:{Accept:'application/json'}});
  if (!response.ok) return;
  const before = await response.json();
  const cart = await applyWelcomeDiscount(before);
  if (cart === before || !cart.sections) return;
  const promise = Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail:{sections:cart.sections, items:cart.items, itemCount:cart.item_count, source:'veyana-welcome', didError:false}});
  document.dispatchEvent(new CartLinesUpdateEvent({action:'update', context:'cart', lines:[], promise}));
}
refreshWelcomeCart().catch(() => {});

document.addEventListener('click', event => {
  const trigger = event.target.closest('.vy-bag');
  const drawer = document.getElementById('cart-drawer');
  if (!trigger || !drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  refreshWelcomeCart().catch(() => {});
  drawer.open();
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.ve form[action*="/cart/add"], .vy-commerce form[action*="/cart/add"]')) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  if (pending || !form.reportValidity()) return;
  pending = true;
  const buttons = [...form.querySelectorAll('[type="submit"]'), ...document.querySelectorAll(`[form="${form.id}"][type="submit"]`)];
  buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
  let message = form.querySelector('.vy-cart-status');
  if (!message) {
    message = document.createElement('p');
    message.className = 'vy-cart-status';
    message.setAttribute('role', 'status');
    form.append(message);
  }
  message.textContent = '';
  const data = new FormData(form);
  data.set('sections', [...new Set([...document.querySelectorAll('cart-items-component')].map(component => component.dataset.sectionId).filter(Boolean))].join(','));
  data.set('sections_url', window.location.pathname);
  const root = window.Shopify.routes.root;
  let added = false;
  try {
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || form.dataset.cartError);
    added = true;
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error(form.dataset.cartRefreshError);
    const cart = await applyWelcomeDiscount(await cartResponse.json());
    const promise = Promise.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {sections: cart.sections || result.sections, items: cart.items, itemCount: cart.item_count, source: 'veyana-product-form', didError: false}});
    form.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: [{merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1}], promise}));
    message.textContent = form.dataset.cartAdded;
    drawer.open();
  } catch (error) {
    message.textContent = added ? form.dataset.cartRefreshError : (error.message || form.dataset.cartError);
    if (added) drawer.open();
  } finally {
    pending = false;
    buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
  }
});

// Recurring delivery is always an explicit selection, never a default.
document.addEventListener('change', event => {
  const choice = event.target.closest('[name="veyana_choice"]');
  if (!choice) return;
  const form = choice.form;
  form.elements.id.value = choice.dataset.variant;
  const plan = form.elements.selling_plan;
  plan.value = choice.dataset.plan;
  plan.disabled = !plan.value;
  form.querySelector('.vy-renewal-note').textContent = plan.value
    ? 'Automatically renews at the price and interval shown, plus applicable shipping and taxes. Cancel, pause, or skip through your customer account before the next renewal.'
    : 'One-time purchase. No recurring charges.';
  document.querySelector('.vy-pdp-price').textContent = choice.dataset.price;
  form.querySelector('[type="submit"]').textContent = plan.value ? `Subscribe and save · ${choice.dataset.price} ${choice.dataset.interval}` : `Add to cart · ${choice.dataset.price}`;
});

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-vy-bundle]');
  if (!button || pending) return;
  pending = true;
  button.disabled = true;
  const status = button.parentElement.querySelector('[data-bundle-status]');
  const root = window.Shopify.routes.root;
  try {
    const beforeResponse = await fetch(`${root}cart.js`);
    if (!beforeResponse.ok) throw new Error('Please try again. Your cart could not be read.');
    const before = await beforeResponse.json();
    const single = before.items.find(item => item.key === button.dataset.singleKey && !item.selling_plan_allocation);
    if (!single) throw new Error('Your cart changed. Please reopen it and try again.');
    const bundleId = Number(button.dataset.vyBundle);
    const existing = before.items.find(item => item.variant_id === bundleId && !item.selling_plan_allocation);
    const updates = {[single.key]: single.quantity - 1, [existing?.key || bundleId]: (existing?.quantity || 0) + 1};
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))];
    const response = await fetch(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})});
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error(cart.description || 'The bundle could not be added. Please try again.');
    const promise = Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:cart.sections,items:cart.items,itemCount:cart.item_count,source:'veyana-bundle',didError:false}});
    button.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[{merchandiseId:String(bundleId),quantity:1}],promise}));
  } catch(error) {status.textContent = error.message;} finally {pending=false;button.disabled=false;}
});
